export interface CitySuggestionLike {
  label: string;
  token: string;
}

export interface SavedCityTokenResolutionInput {
  savedCity?: string | null;
  savedCitySelectionToken?: string | null;
  currentCity: string;
  currentCitySelectionToken: string;
}

export function needsSavedCityTokenResolution(input: SavedCityTokenResolutionInput): boolean {
  const savedCity = input.savedCity?.trim();
  if (!savedCity || input.savedCitySelectionToken || input.currentCitySelectionToken) {
    return false;
  }

  return normalizeCityLabel(input.currentCity) === normalizeCityLabel(savedCity);
}

export function pickExactCitySuggestion<T extends CitySuggestionLike>(
  items: readonly T[],
  city: string,
): T | null {
  const target = normalizeCityLabel(city);
  if (!target) return null;

  return items.find((item) => normalizeCityLabel(item.label) === target) ?? null;
}

function normalizeCityLabel(value: string): string {
  return value
    .trim()
    .replace(/\s+/g, " ")
    .replace(/^(?:\u0433\.?|\u0433\u043e\u0440\u043e\u0434)\s+/iu, "")
    .toLocaleLowerCase("ru-RU");
}
